export type ValidationErrorTypes = 'error' | 'warning'

export interface ValidationError {
  type: ValidationErrorTypes
  message: string
}

export type ServerError = {
  error: {
    message: string
    title: string
    code: string
    keys: any
    messages: any
  }
}

export enum API_SOCIAL_SERVICE_EXEPTION {
  EMPTY_RESPONSE = 'ApiSocialServiceException.instagram.emptyResponse'
}